<template>
  <div class="shop-screen detail-screen">
    <header class="shop-header">
      <button
        class="back"
        @click="$router.back()"
      >
        <van-icon name="arrow-left" />
      </button>
      <h1>{{ $t('shop.orderDetails') }}</h1>
    </header>
    <main v-if="order">
      <section class="summary">
        <h2>{{ $t('shop.productSummary') }}</h2>
        <article
          v-for="item in order.items"
          :key="item.id"
          class="summary-item"
        >
          <img
            :src="item.image"
            :alt="item.title"
          >
          <div>
            <p>{{ item.title }}</p>
            <strong>{{ money(item.line_amount) }}</strong>
          </div>
          <span>x{{ item.quantity }}</span>
        </article>
      </section>
      <section class="pricing">
        <div><span>{{ $t('shop.productPrice') }}</span><strong>{{ money(order.market_amount) }}</strong></div>
        <div><span>{{ $t('shop.freight') }}</span><strong>{{ money(order.freight_amount) }}</strong></div>
        <div><span>{{ $t('shop.discountedPrice') }}</span><strong>{{ money(order.discount_amount) }}</strong></div>
        <div class="total-row">
          <b>{{ $t('shop.totalPrice') }}</b><strong>{{ money(order.pay_amount) }}</strong>
        </div>
      </section>
      <section class="balance">
        <div><span>{{ $t('shop.balance') }}</span><strong>{{ money(order.balance) }}</strong></div>
        <div><span>{{ $t('shop.payBalance') }}</span><strong>{{ money(order.pay_amount) }}</strong></div>
      </section>
    </main>
    <footer
      v-if="order && order.status === 'pending'"
      class="single-action"
    >
      <button
        :disabled="submitting"
        @click="pay"
      >
        {{ $t('shop.pay') }}
      </button>
    </footer>
    <footer
      v-if="order && order.status === 'paid'"
      class="single-action"
    >
      <button
        :disabled="submitting || order.repurchase_status !== 'none'"
        @click="repurchase"
      >
        {{ order.repurchase_status === 'none' ? $t('shop.applyRepurchase') : $t('shop.repurchasePending') }}
      </button>
    </footer>
  </div>
</template>

<script>
import Fetch from '@/utils/fetch';

export default {
    data() {
        return { order: null, submitting: false };
    },
    mounted() {
        this.$parent.footer('item', false);
        this.load();
    },
    methods: {
        money(value) {
            return this.$formatPen(value);
        },
        load() {
            Fetch('/shop/orderDetail', { order_id: this.$route.params.id }, null, true).then((res) => {
                this.order = res.data;
            });
        },
        pay() {
            if (this.submitting) return;
            this.submitting = true;
            Fetch('/shop/orderPay', { order_id: this.order.id }, null, true).then(() => {
                this.$router.replace('/orderhis');
            }).finally(() => {
                this.submitting = false;
            });
        },
        repurchase() {
            if (this.submitting || this.order.repurchase_status !== 'none') return;
            this.submitting = true;
            Fetch('/shop/repurchaseApply', { order_id: this.order.id }, null, true).then(() => this.load()).finally(() => {
                this.submitting = false;
            });
        }
    }
};
</script>

<style scoped>
.shop-screen { min-height: 100vh; background: #f5f5f5; padding-bottom: 62px; color: #333; }
.shop-header { display: flex; position: relative; height: 50px; align-items: center; justify-content: center; background: #fff; border-bottom: 1px solid #eee; }
.shop-header h1 { margin: 0; color: #333; font-size: 16px; font-weight: 500; }
.back { position: absolute; left: 16px; border: 0; background: transparent; color: #ee4d2d; font-size: 18px; }
.summary, .pricing, .balance { padding: 16px; background: #fff; }
.summary { margin-top: 10px; }
.summary h2 { margin: 0 0 12px; color: #333; font-size: 16px; font-weight: 500; }
.summary-item { display: flex; min-height: 100px; gap: 12px; align-items: center; }
.summary-item img { width: 82px; height: 82px; object-fit: contain; }
.summary-item > div { flex: 1; min-width: 0; }
.summary-item p { display: -webkit-box; margin: 0 0 14px; overflow: hidden; color: #333; font-size: 13px; line-height: 18px; -webkit-box-orient: vertical; -webkit-line-clamp: 2; }
.summary-item strong { color: #ee4d2d; font-size: 14px; }
.summary-item > span { align-self: flex-end; margin-bottom: 12px; color: #888; font-size: 12px; }
.pricing { margin-top: 10px; }
.pricing > div, .balance > div { display: flex; min-height: 42px; justify-content: space-between; align-items: center; border-bottom: 1px solid #eee; color: #777; font-size: 12px; }
.pricing strong, .balance strong { color: #555; font-weight: 400; }
.pricing .total-row { border-bottom: 0; color: #333; }
.total-row b, .balance > div:last-child strong { color: #ee4d2d; font-weight: 600; }
.balance { margin-top: 10px; }
.balance > div:last-child { border-bottom: 0; }
.single-action { position: fixed; right: 0; bottom: 0; left: 0; z-index: 10; padding: 8px 16px calc(8px + env(safe-area-inset-bottom, 0px)); background: #fff; box-shadow: 0 -1px 4px rgba(0, 0, 0, .08); }
.single-action button { width: 100%; height: 42px; border: 0; border-radius: 4px; background: #ee4d2d; color: #fff; font-size: 14px; font-weight: 500; }
.single-action button:disabled { background: #d8d8d8; }
</style>
